import axios from 'axios';
import { API_BASE_URL } from '../../../config';

// One thin wrapper per server route (spec §5.2). Components never call axios
// directly, so tests mock this module and nothing else.
const CFG = { withCredentials: true };
const base = `${API_BASE_URL}/api/admin/it-apps`;

const appOf = (r) => r.data?.app;

/** All apps, retired included. A malformed body is a failed read, never an empty list. */
export function listItApps() {
  return axios.get(base, CFG).then((r) => {
    const apps = r.data?.apps;
    if (!Array.isArray(apps)) throw new Error('bad_response');
    return apps;
  });
}

export const createItApp = (body) => axios.post(base, body, CFG).then(appOf);
export const updateItApp = (id, body) => axios.put(`${base}/${id}`, body, CFG).then(appOf);
export const retireItApp = (id) => axios.post(`${base}/${id}/retire`, {}, CFG).then(appOf);
export const restoreItApp = (id) => axios.post(`${base}/${id}/restore`, {}, CFG).then(appOf);

// Tools catalog link. A malformed body is a failed read, never "no tools".
export function searchToolOptions(q) {
  return axios.get(`${base}/tool-options`, { ...CFG, params: q ? { q } : {} }).then((r) => {
    const tools = r.data?.tools;
    if (!Array.isArray(tools)) throw new Error('bad_response');
    return tools;
  });
}

/** Creates a catalog tool from the app and links it: `{ app, tool }`. */
export const addItAppToCatalog = (id, body) => axios.post(`${base}/${id}/catalog-tool`, body, CFG).then((r) => r.data);

export function listToolCategories() {
  return axios.get(`${API_BASE_URL}/api/categories`, CFG).then((r) => {
    if (!Array.isArray(r.data)) throw new Error('bad_response');
    return r.data;
  });
}
